import React, { memo } from "react";
import { Grid } from "@mui/material";
import TextInput from "../../../common/formElements/TextInput";

const KEKFields = () => {
    return (
        <Grid item xs={12} md={12}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={5}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                            <TextInput
                                fieldname="attributes.KEKVersion"
                                label="KEK Version"
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={5}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                            <TextInput
                                fieldname="attributes.KEKIdentifier"
                                label="KEK Identifier"
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
};

export default memo(KEKFields);
